module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/question/question.component.css
// module id = ./src/app/assessments/question/question.component.css
// module chunks = main